import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { Info } from '../../assets/icons';
import useMediaQuery from '../../Hooks/useMediaQuery';
import PropertyBuyCard from '../PropertyBuyCard/PropertyBuyCard';
import PropertyTradeCard from '../PropertyTradeCard/PropertyTradeCard';
import './PropertyBasic.scss';
import { useSelector } from 'react-redux';
import { getUsCurrencyFormat } from '../../utils/usCurrencyFormatter';
import { basicData } from '../../pages/PropertyListing/IOVacationData';
import { PROPERTY_SUB_TYPE, PROPERTY_TYPES, TOOLTIP_TEXT } from '../../utils/constant';
import { multiBasicData } from '../../pages/PropertyListing/IOMultiData';
import { getDataFromObject } from '../../utils';
import { useParams } from 'react-router-dom';

const PropertyBasic = (props) => {
  const screenMD = useMediaQuery('(min-width: 1000px)');
  const { data } = useSelector((state) => state.propertyDetails);
  const { propertyType } = useParams();

  const currentBasicData = useMemo(() => {
    switch (data?.data?.propertyTypeName?.toLowerCase()) {
      case PROPERTY_SUB_TYPE.MULTI?.toLocaleLowerCase():
        return multiBasicData;

      default:
        return basicData;
    }
  }, [data?.data?.propertyTypeName]);
  const { basics } = currentBasicData;

  return (
    <div className='property-basic'>
      <div className='basic-list fz-16 mb-24'>
        {basics?.map((basic, index) => {
          let value = basic?.key ? getDataFromObject(data, basic?.key) : data?.data?.[basic?.value];
          if (value) {
            return (
              <React.Fragment key={index}>
                <span>
                  {basic.prefix} {value} {basic.suffix}
                </span>
                <span className='text-taupe-60 dot ml-4 mr-4'> • </span>
              </React.Fragment>
            );
          }
          return null;
        })}
      </div>
      {!screenMD &&
        (propertyType === PROPERTY_TYPES.SECONDARY ? (
          <PropertyTradeCard onNotifyClick={props?.onNotifyClick} clickAction={props.onTradeClick} {...props.cardData} />
        ) : (
          <PropertyBuyCard onNotifyClick={props?.onNotifyClick} onBuyClick={props?.onBuyClick} isFetchingUserAccount={props?.isFetchingUserAccount} />
        ))}
      <div className='prop-list'>
        <div className='prop-list__item'>
          <span className={'prop-list__item__label'}>Property type</span>
          <span className='prop-list__item__value'>{data.data?.propertyTypeName}</span>
        </div>
        <div className='prop-list__item'>
          <span className={'prop-list__item__label'}>Location</span>
          <span className='prop-list__item__value'>
            {data.data?.city}, {data.data?.state}
          </span>
        </div>
        <div className='prop-list__item'>
          {/* TODO: get info about content in tooltip */}
          <Tooltip title={TOOLTIP_TEXT.PURCHASE_PRICE}>
            <span className={'prop-list__item__label tooltip'}>
              Purchase price <Info verticalAlign='text-bottom' marginLeft='8px' />
            </span>
          </Tooltip>
          <span className='prop-list__item__value'>${getUsCurrencyFormat(Number(data.data?.finance?.purchasePrice) || 0)}</span>
        </div>
        <div className='prop-list__item'>
          <span className={'prop-list__item__label'}>
            {data.data?.propertyTypeName?.toLowerCase() === PROPERTY_SUB_TYPE.VACATION?.toLowerCase() ? 'Avg cost to rent' : 'Monthly rent'}
          </span>
          <span className='prop-list__item__value'>
            $
            {data?.data?.propertyTypeName?.toLowerCase() === PROPERTY_SUB_TYPE.VACATION?.toLowerCase()
              ? `${getUsCurrencyFormat(Number(data.data?.rentPerNight ?? 0))}/night`
              : getUsCurrencyFormat(Number(data?.data?.rentPerMonth ?? 0))}
          </span>
        </div>
      </div>
    </div>
  );
};

PropertyBasic.propTypes = {
  propertyType: PropTypes.string,
  bedrooms: PropTypes.string,
  bathrooms: PropTypes.string,
  area: PropTypes.string,
  build: PropTypes.string,
};

export default PropertyBasic;
